import React, {useEffect, useState} from 'react';
import {appdata} from "../../logic_tmp/appdata/AppData";
import './Price.css';
import {calcResource, getImpl, lgSetup} from "../../backend/LgSetup";
import {MDBCard, MDBCardBody, MDBCardImage, MDBCardText, MDBCardTitle} from "mdb-react-ui-kit";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";
import i18next from "i18next";


export function PackagesBlock() {
    const { t } = useTranslation();
    let packages = appdata.product["packages"]
    const history = useHistory();
    function packagesEnabled() {
        return (packages !== undefined)
    }
    let counter = 0;
    return (

        <div>
            {(packagesEnabled())?
                <div>
                    <h2 className="offer-pay__title"/>
                    <br/>
                    <h2 className="offer-pay__title">
                        {t("PleaseReadInformationAboutPackages")}
                    </h2>
                    <br/>
                    {Object.keys(packages).map((pKey) => {
                        counter++
                        let utm =
                            "utm_source=" + appdata.utm_source +
                            "&utm_medium=" + appdata.utm_medium +
                            "&utm_campaign=" + appdata.utm_campaign +
                            "&utm_content=" + appdata.utm_content +
                            "&utm_brand=" + appdata.utm_brand +
                            "&referenceId=" + appdata.referenceId +
                            "&message=" + appdata.message;
                        let pack = lgSetup.products[pKey]
                        let packData = pack["packageData"]
                        let motivationKey = packData["motivationKey"][counter]
                        let priceOfOneTicket =  packData["pricePerTicket"]
                        let image =  calcResource(pack["path"], getImpl(pack,["miniposterResource"]))
                        let buttonText =  t(packData["buttonKey"])
                        let motivationText = t(motivationKey,{price:priceOfOneTicket})
                        let href = ""
                        if (packData["redirectToHomePage"])
                        {
                            href = pack["homepageUrl"] + "?" + utm + "&lng="  + i18next.language
                        }
                        else {
                            href = "/begin?productCode=" + pack["productCode"] + "&" + utm + "&lng="  + i18next.language
                        }
                        let priceInfoText =  t(packData["priceInfo"], {fullPrice:pack.fullPrice, oneTicketPrice:priceOfOneTicket})
                        //Bilet -> Abonement - и название кнопок
                        return (
                            <div key = {pKey}>
                                <div className="table">{motivationText}</div>

                                <MDBCard className='mb-3' key = {pKey}>
                                    <MDBCardImage position='top' src={image} alt='...' />
                                    <MDBCardBody key = {pKey}>
                                        <MDBCardText className="bigfont, red">{priceInfoText}<br/><br/></MDBCardText>
                                        <MDBCardTitle><a className="g-btn app-btn-further next-step-btn" href={href}>{buttonText} </a></MDBCardTitle>
                                    </MDBCardBody>
                                </MDBCard>
                            </div>
                        )
                    })
                    }
                </div>
                :<div/>}
        </div>
    );
}
